import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    makeStyles,
    Typography
} from "@material-ui/core";
import React, {FC} from "react";
import {useHistory} from "react-router-dom";
import {useEditorLocation} from "../../../editor/editor.hook";
import {addHours, getDate, getHours, getMinutes, getMonth, getYear, set} from "date-fns";
import {WorkerAutoComplete} from "../../workers/sharedComponents/WorkerAutoComplete";
import {useCreateAvailability} from "../redux/availabilities.hook";
import {DatePicker, TimePicker} from "@material-ui/pickers";
import {InfoOutlined} from "@material-ui/icons";
import {MaterialUiPickersDate} from "@material-ui/pickers/typings/date";

const useStyles = makeStyles(theme => ({
    spacing: {
        marginRight: theme.spacing(1)
    },
    formContainer: {
        paddingBottom: theme.spacing(4)
    },
    select: {
        width: 100
    }
}));

const getInitialDate = (date?: number) => date ? set(date, {
    minutes: 0,
    hours: 10
}): set(new Date(), {
    minutes: 0,
    hours: 10
});

export const CreateAvailabilityDialogForm: FC<{ hideWorkerSelect?: boolean }> = ({hideWorkerSelect}) => {

    const classes = useStyles();
    const history = useHistory();
    const [isLoading, setIsLoading] = React.useState(false);
    const {mode, reference, workerId, initialDate} = useEditorLocation();
    const dialogOpen = mode === 'create' && reference === 'availability';
    const closeDialog = () => {
        const newSearchParams = new URLSearchParams(history.location.search);
        newSearchParams.delete('mode');
        newSearchParams.delete('workerId');
        history.replace({
            pathname: history.location.pathname,
            search: `${newSearchParams.toString()}`,
            hash: undefined
        })
    };

    console.log("dialog", workerId);
    const {createAvailability} = useCreateAvailability();

    const [from, setFrom] = React.useState(() => getInitialDate(initialDate));
    const [to, setTo] = React.useState(() => addHours(getInitialDate(initialDate), 8));
    const [selectedWorkerId, setSelectedWorkerId] = React.useState("");

    React.useEffect(() => {
        if(initialDate !== undefined) {
            setFrom(getInitialDate(initialDate))
            setTo(addHours(getInitialDate(initialDate), 8))
        }
    }, [initialDate])

    const handleUpdateDate = (date: MaterialUiPickersDate) => {
        if (date) {
            setFrom(set(from, {
                year: getYear(date),
                month: getMonth(date),
                date: getDate(date)
            }))
        }
    };

    const handleUpdateTime = (target: "from" | "to", time: MaterialUiPickersDate) => {
        if (time) {
            if (target === "from") {
                setFrom(
                    set(from, {
                        minutes: getMinutes(time),
                        hours: getHours(time)
                    }));
            } else {
                setTo(
                    set(to, {
                        minutes: getMinutes(time),
                        hours: getHours(time)
                    }));
            }
        }
    };

    const handleCreateAvailability = () => {
        setIsLoading(true);
        createAvailability({
            workerId: workerId || selectedWorkerId || "",
            from: from.getTime(),
            to: to.getTime()
        })
            .then(() => {
                setIsLoading(false);
                history.replace({search: undefined});
            })
            .catch(() => {
            })
    }

    return (
        <Dialog open={dialogOpen} onClose={closeDialog}>
            <DialogTitle>
                <Typography variant="inherit" color="primary">
                    Neue Verfügbarkeit
                </Typography>
            </DialogTitle>
            <DialogContent className={classes.formContainer}>
                <Grid container spacing={2}>
                    {!hideWorkerSelect &&
                    <Grid item xs={12}>
                        <WorkerAutoComplete
                            onChange={(worker) => {
                                if(worker){
                                    setSelectedWorkerId(worker.id);
                                }
                            }}
                            selectedId={workerId || selectedWorkerId}
                        />
                    </Grid>}
                    <Grid item xs={12}>
                        <DatePicker
                            cancelLabel={"Zurück"}
                            disablePast
                            fullWidth
                            label="Datum"
                            value={from}
                            onChange={handleUpdateDate}
                            animateYearScrolling
                            format="EEEE, dd.MM.yyyy"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TimePicker
                            cancelLabel={"Zurück"}
                            minutesStep={15}
                            fullWidth
                            ampm={false}
                            label="Start"
                            value={from}
                            onChange={(date) => handleUpdateTime("from", date)}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TimePicker
                            cancelLabel={"Zurück"}
                            minutesStep={15}
                            fullWidth
                            ampm={false}
                            label="Ende"
                            value={to}
                            onChange={(date) => handleUpdateTime("to", date)}
                        />
                    </Grid>
                </Grid>
                <div style={{display: "flex", marginTop: 24}}>
                    <InfoOutlined color="primary"/>
                    <Typography variant="body2" style={{marginLeft: 8}} color="textSecondary">
                        Eventuell kommt hier noch ein Hifetext rein.
                    </Typography>
                </div>
            </DialogContent>
            <DialogActions>
                {isLoading ?
                    <CircularProgress/> :
                    (<>
                        <Button onClick={closeDialog}>
                            Abbrechen
                        </Button>
                        <Button color="primary" onClick={handleCreateAvailability}>
                            Speichern
                        </Button>
                    </>)}
            </DialogActions>
        </Dialog>
    )
}
